import type { ReapproNeedAdjustmentDTO } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchReapproCategoryUpcomingDeliveries = async (categoryId: number) => {
  const response = await gozokiApiWithAuth.get<{ deliveryDates: string[] }>(
    `/reappro-categories/${categoryId}/upcoming-deliveries`,
  )
  return response.data.deliveryDates
}

export const fetchReapproCategoryNeedAdjustments = async (categoryId: number) => {
  const response = await gozokiApiWithAuth.get<{ adjustments: ReapproNeedAdjustmentDTO[] }>(
    `/reappro-categories/${categoryId}/need-adjustments`,
  )
  return response.data.adjustments
}
